import React, { useCallback, useEffect, useMemo, useState } from 'react'
import Cargando from '../../Varios/Cargando';
import { SolicitudesVacacionesPorRegistrarTH } from './TypesRegistroSolicitudesV';
import TablaRegistroSolicitudesV2 from './TablaRegistroVacaciones2';
import { UserData } from 'components/Sidebar/Sidebar_Principal';
import { authenticationService } from 'services/authentication.service';
import { GetDocumentVistaPrevia } from 'helpers/files';
import ModalVistaPreviaDocumentos from 'components/Varios/Modals/ModalVistaPreviaDocumentos';

import { Container, Table, Row, Col, Label, Input, Button } from 'reactstrap'
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import ModalRechazo from 'components/DirectivoUnidad/AprobacionSolicitudes/ModalRechazoSolicitud';
import { alertService } from 'components/Varios/alert_service';
import { ScrollToTop } from 'functions/LayoutFunctionst';
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import { ResponseRequest } from 'components/Types/GeneralTypes';
import ModalVistaPreviaDocumentosAccion from 'components/Varios/Modals/ModalVistaPreviaDocumento';
import Swal from 'sweetalert2';

import ExitoSVG from "./../../../assets/icons/Permisos/Exitosa.svg"
import ErrorSVG from "./../../../assets/icons/Permisos/Error.svg"
import AnuncioSVG from "assets/icons/Permisos/Anuncio.svg"
import { ObtenerInformacionRegistros, VistaPreviaSolicitudVacaciones, RegistrarSolicitudVacaciones, AnularAccionPersonalVacacion, FirmaMasivaAccionPersonal } from './FunctionsRegistroV';

type StateRegistroSolicitudes = {
    filasTabla: SolicitudesVacacionesPorRegistrarTH[],
    loadingFilas: boolean,
    errorFilas: boolean,
    mensajeAprobacion: string | undefined,
    mensajeError: string | undefined,
}

type StateModalVistaPrevia = {
    loading: boolean,
    url: string
}

type StateModalInformacionRegistrarVacaciones = {
    url: string,
    cargando: boolean,
    idSolicitud: number,
    tipoSolicitud: string,
    modalContent: HTMLElement | undefined,
    tituloModal: string
}

type StateModalAprobacionMasicaAccionPersonal = {
    cargando: boolean,
    modalContent: HTMLElement | undefined,
    filasTabla: SolicitudesVacacionesPorRegistrarTH[]
}

type StateModalInformacionRechazar = {
    cargando: boolean,
    idSolicitud: number,
    tipoSolicitud: string,
    modalContent: HTMLElement | undefined,
    observacion: string
}

export function showAlertSwal(message: string, isSuccess: boolean) {
    Swal.fire({
        text: message,
        imageUrl: isSuccess ? `${ExitoSVG}` : `${ErrorSVG}`,
        imageHeight: 100,
        imageAlt: isSuccess ? "Éxito" : "Error",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#243165",
    });
}

export function showAlertHTMLSwal(message: string, isSuccess: boolean) {
    Swal.fire({
        html: message,
        imageUrl: isSuccess ? `${ExitoSVG}` : `${ErrorSVG}`,
        imageHeight: 100,
        imageAlt: isSuccess ? "Éxito" : "Error",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#243165",
    });
}

export function showAlertSwalAnuncio(message: string) {
    Swal.fire({
        text: message,
        imageUrl: `${AnuncioSVG}`,
        imageHeight: 100, // Ajusta el tamaño según sea necesario
        imageAlt: "Anuncio",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#243165",
    });
}

export default function RegistroSolicitudesV() {
    const TITULO_REGISTRO_SOLICITUDES = "REGISTRO Y CONTROL DE AP DE VACACIONES/REINTEGRO";

    const defaulState: StateRegistroSolicitudes = {
        filasTabla: [],
        loadingFilas: false,
        errorFilas: false,
        mensajeAprobacion: undefined,
        mensajeError: undefined,
    }

    const defaultStateModalVistaPrevia: StateModalVistaPrevia = {
        loading: false,
        url: ""
    }

    const defaultStateModalRevisarVacaciones: StateModalInformacionRegistrarVacaciones = {
        url: "",
        cargando: false,
        idSolicitud: -1,
        tipoSolicitud: "",
        modalContent: undefined,
        tituloModal: "Registro y Control de Solicitud de Vacaciones/Reintegro"
    }

    const defaultSateModalAprobacionMasivaAccionPersonal: StateModalAprobacionMasicaAccionPersonal = {
        cargando: false,
        modalContent: undefined,
        filasTabla: []
    }

    const defaultStateModalInformacionAnular: StateModalInformacionRechazar = {
        cargando: false,
        idSolicitud: -1,
        tipoSolicitud: "",
        modalContent: undefined,
        observacion: ""
    }

    const [stateRegistro, setstateRegistro] = useState<StateRegistroSolicitudes>(defaulState)
    const [stateModalVP, setstateModalVP] = useState<StateModalVistaPrevia>(defaultStateModalVistaPrevia)

    const [stateinformacionModalRegistrarAP, setstateinformacionModalRegistrarAP] = useState(defaultStateModalRevisarVacaciones)
    const [stateModalAprobacionMasivaAccionPersonal, setstateModalAprobacionMasivaAccionPersonal] = useState(defaultSateModalAprobacionMasivaAccionPersonal)
    const [stateinformacionModalAnular, setstateinformacionModalAnular] = useState(defaultStateModalInformacionAnular)

    const [observacion, setobservacion] = useState("");

    async function showAlert(message, imageSrc, isSuccess) {
        Swal.fire({
            text: message,
            imageUrl: `${imageSrc}`,
            imageHeight: 100,
            imageAlt: isSuccess ? "Éxito" : "Error",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#243165",
        });
    }

    async function ObtenerDatosRegistros() {
        setstateRegistro({ ...stateRegistro, loadingFilas: true })
        const resultado = await ObtenerInformacionRegistros()
        if (resultado.status === 200) {
            if (typeof (resultado.dataResponse) === "string") {
                setstateRegistro({ ...stateRegistro, mensajeAprobacion: resultado.dataResponse, loadingFilas: false })
            }
            else {
                setstateRegistro({ ...stateRegistro, filasTabla: resultado.dataResponse, loadingFilas: false })
            }
        } else {
            setstateRegistro(prev => ({ ...prev, mensajeError: resultado.errorMessage, loadingFilas: false, errorFilas: true }));

        }
    }

    const onClickVerDoc = useCallback(
        async (referencia: string) => {
            setstateModalVP({ ...stateModalVP, loading: true })
            const datosUsuario: UserData = authenticationService.currentUserValue;
            const url = await GetDocumentVistaPrevia(referencia, datosUsuario.token);
            setstateModalVP({ ...stateModalVP, loading: false, url })
        }, [stateModalVP])

    useEffect(() => {
        window.location.href = "https://th.espol.edu.ec/";
        //ObtenerDatosRegistros();
    }, [])

    async function OnCloseModalRegistro() {
        setstateinformacionModalRegistrarAP(defaultStateModalRevisarVacaciones)
        await ObtenerDatosRegistros()
        ScrollToTop();
    }

    function onClickAprobacionMasiva(informacionAcciones) {

        const modalContent = AuxiliarGenerarHTMLBodyModalSolicitudes(informacionAcciones)
        setstateModalAprobacionMasivaAccionPersonal({
            cargando: false,
            filasTabla: informacionAcciones,
            modalContent
        })
    }

    function AuxiliarGenerarHTMLBodyModalSolicitudes(informacionAcciones): any {
        return (
            <>
                <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                    <thead className="cabecerasDetallehistorialSolic">
                        <tr className="" >
                            <th> Tipo Solicitud</th>
                            <th> Fecha Solicitud</th>
                            <th> Nombre</th>
                            <th> Fecha Desde</th>
                            <th> Fecha Hasta</th>
                            <th> Días </th>
                            <th> Estado Solicitud</th>
                        </tr>
                    </thead>
                    <tbody>

                        {informacionAcciones.map((solicitudes, ind) => {

                            return (
                                <tr key={"trMasivoSolicVac" + ind} className="rowHistorialSolicitudVacaciones">
                                    <td className="">
                                        <div className="">
                                            {solicitudes.tipoSolicitud}
                                        </div>
                                    </td>
                                    <td className="">
                                        <div className="">
                                            {ObtenerFechaFromIsoFormat(solicitudes.fechaSolicitud)}
                                        </div>
                                    </td>
                                    <td className="">
                                        <div className="">
                                            {solicitudes.nombres}
                                        </div>
                                    </td>
                                    <td className="">
                                        <div className="">
                                            {ObtenerFechaFromIsoFormat(solicitudes.fechaInicio)}
                                        </div>
                                    </td>
                                    <td className="">
                                        <div className="">
                                            {ObtenerFechaFromIsoFormat(solicitudes.fechaFin)}
                                        </div>
                                    </td>
                                    <td className="">
                                        <div className="">
                                            {solicitudes.tiempo}
                                        </div>
                                    </td>
                                    <td className="">
                                        <div className="">
                                            {solicitudes.estadoParse}
                                        </div>
                                    </td>
                                </tr>
                            )
                        })}

                    </tbody>
                </Table>
            </>
        )
    }

    async function OnCloseModalAnulacion() {
        await ObtenerDatosRegistros()
        setstateinformacionModalAnular(defaultStateModalInformacionAnular)
        ScrollToTop();
    }

    const tablaRegistros = useMemo(() => {
        const { loadingFilas, errorFilas, filasTabla, mensajeError } = stateRegistro
        if (loadingFilas) {
            return <Cargando mensaje='Cargando Solicitudes' />;
        }
        else if (!loadingFilas && errorFilas && mensajeError === undefined) {
            return <div>No ha sido posible cargar la información</div>
        } else if (!loadingFilas && errorFilas && mensajeError) {
            return <div className="alert alert-danger">{mensajeError}</div>;
        }
        else if (filasTabla.length > 0) {
            return (
                <TablaRegistroSolicitudesV2
                    dataFilas={stateRegistro.filasTabla}
                    onClickVerDocumento={async (referencia: string) => await onClickVerDoc(referencia)}
                    onClickRegistrar={(solicitud: any) => onClickAprobarParcialmenteSolicitudVacaciones(solicitud)}
                    onClickRechazar={(solicitud: any) => onClickAnularAccionPersonal(solicitud)}
                    onClickRegistroMasivo={async (solicitudes: SolicitudesVacacionesPorRegistrarTH[]) => await onClickAprobacionMasiva(solicitudes)}
                />
            )
        }
        else {
            return (
                <TablaRegistroSolicitudesV2
                    dataFilas={[]}
                    onClickVerDocumento={async (referencia: string) => { ; }}
                    onClickRegistrar={(solicitud: any) => { ; }}
                    onClickRechazar={(solicitud: any) => { ; }}
                    onClickRegistroMasivo={async (solicitudes: SolicitudesVacacionesPorRegistrarTH[]) => { ; }}
                />
            )
        }
    }, [stateRegistro])

    function onClickAnularAccionPersonal(informacionAcciones) {
        const modalContent = AuxiliarGenerarHTMLBodyModalAnular(informacionAcciones);

        setstateinformacionModalAnular({
            cargando: false,
            idSolicitud: informacionAcciones.idSolicitudVacacion,
            tipoSolicitud: informacionAcciones.tipoSolicitud,
            modalContent,
            observacion
        })
    }

    async function AnularAP(idSolicitud, observacion, tipoSolicitud) {
        const respuesta = await AnularAccionPersonalVacacion(idSolicitud, observacion, tipoSolicitud)
        if (respuesta.status !== 200) {
            await showAlert(respuesta.errorMessage, ErrorSVG, false);
            return 1;
        }
        else {
            await showAlert("Se ha anulado la acción de personal", ExitoSVG, true);
            return -1
        }
    }

    async function onClickAprobarParcialmenteSolicitudVacaciones(informacionAcciones) {
        var titulo = "";
        var respuestaSolicitud: ResponseRequest = { status: -1 };
        respuestaSolicitud = await VistaPreviaSolicitudVacaciones(informacionAcciones.idSolicitudVacacion, informacionAcciones.tipoSolicitud);
        if (respuestaSolicitud.status === 200) {
            var content: any = undefined;
            if (informacionAcciones.tipoSolicitud == "Reintegro Vacación") {
                titulo = "Acción de Personal de Reintegro"
                setstateinformacionModalRegistrarAP({
                    url: respuestaSolicitud.dataResponse,
                    cargando: false,
                    tituloModal: titulo,
                    modalContent: content,
                    idSolicitud: informacionAcciones.idSolicitudVacacion,
                    tipoSolicitud: informacionAcciones.tipoSolicitud
                })
            } else {
                titulo = "Acción de Personal de Vacaciones"
                setstateinformacionModalRegistrarAP({
                    url: respuestaSolicitud.dataResponse,
                    cargando: false,
                    tituloModal: titulo,
                    modalContent: content,
                    idSolicitud: informacionAcciones.idSolicitudVacacion,
                    tipoSolicitud: informacionAcciones.tipoSolicitud
                })
            }
        }
        else {
            alertService.error(respuestaSolicitud.errorMessage ?? "");
        }             
    }

    async function OnClickAccionModalFormulario(idSolicitud, tipoSolicitud) {
        setstateinformacionModalRegistrarAP({ ...defaultStateModalRevisarVacaciones, cargando: true })
        var accionRealizada = await RegistrarSolicitudVacaciones(idSolicitud, tipoSolicitud)
        setstateinformacionModalRegistrarAP(defaultStateModalRevisarVacaciones)
        await ObtenerDatosRegistros();
    }

    function AuxiliarGenerarHTMLBodyModalAnular(informacionAcciones): any {
        return (
            <>
                <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                    <thead className="cabecerasDetallehistorialSolic">
                        <tr className="" >
                            <th> Tipo Solicitud</th>
                            <th> Fecha Solicitud</th>
                            <th> Nombre</th>
                            <th> Fecha Desde</th>
                            <th> Fecha Hasta</th>
                            <th> Días </th>
                            <th> Estado Solicitud</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="rowHistorialSolicitudVacaciones">
                            <td className="">
                                <div className="">
                                    {informacionAcciones.tipoSolicitud}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaSolicitud)}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.nombres}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaInicio)}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {ObtenerFechaFromIsoFormat(informacionAcciones.fechaFin)}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.tiempo}
                                </div>
                            </td>
                            <td className="">
                                <div className="">
                                    {informacionAcciones.estadoParse}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </>
        )
    }

    async function OnCloseModalAprobacionMasiva() {
        setstateModalAprobacionMasivaAccionPersonal(defaultSateModalAprobacionMasivaAccionPersonal)
        await ObtenerDatosRegistros();
    }

    return (
        <div className="content">
            <div className="titulo_seccion mb-5"> {TITULO_REGISTRO_SOLICITUDES} </div>
            {tablaRegistros}

            <ModalVistaPreviaDocumentos
                cargandoDatos={stateModalVP.loading}
                onClose={() => setstateModalVP(defaultStateModalVistaPrevia)}
                show={stateModalVP.loading || stateModalVP.url !== ""}
                size="xl"
                tituloModal='Documento de vacaciones/reintegro'
                urlArchivo={stateModalVP.url}
                botonCerrar={true}
            />

            <ModalVistaPreviaDocumentosAccion
                show={stateinformacionModalRegistrarAP.url !== "" || stateinformacionModalRegistrarAP.cargando}
                onClose={() => setstateinformacionModalRegistrarAP(defaultStateModalRevisarVacaciones)}
                accionOnAccept={true}
                cargandoDatos={stateinformacionModalRegistrarAP.cargando}
                size="xl"
                tituloModal={stateinformacionModalRegistrarAP.tituloModal}
                urlArchivo={stateinformacionModalRegistrarAP.url}
                asyncAccion={() => OnClickAccionModalFormulario(stateinformacionModalRegistrarAP.idSolicitud, stateinformacionModalRegistrarAP.tipoSolicitud)}
                disabledbuttonCondition={stateinformacionModalRegistrarAP.cargando}
                modalContent={stateinformacionModalRegistrarAP.modalContent}
            />

            <ModalConfirmacion
                show={stateModalAprobacionMasivaAccionPersonal.filasTabla.length > 0}
                size="lg"
                onClose={() => setstateModalAprobacionMasivaAccionPersonal(defaultSateModalAprobacionMasivaAccionPersonal)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea registrar las siguientes Acciones de Personal?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={() => FirmaMasivaAccionPersonal(stateModalAprobacionMasivaAccionPersonal.filasTabla)}
                contentModal={stateModalAprobacionMasivaAccionPersonal.modalContent}
                tituloModal={"Registro y Control masivo de Acción de Personal"}
                asyncAfterOnClose={() => OnCloseModalAprobacionMasiva()}
                botonesAccionParteSuperior={true}
            />

            <ModalRechazo
                show={stateinformacionModalAnular.idSolicitud > 0 || stateinformacionModalAnular.cargando}
                size="lg"
                onClose={() => setstateinformacionModalAnular(defaultStateModalInformacionAnular)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea anular la acción de personal?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={(observacion) => AnularAP(stateinformacionModalAnular.idSolicitud, { Observacion: observacion }, stateinformacionModalAnular.tipoSolicitud)}
                contentModal={stateinformacionModalAnular.modalContent}
                tituloModal={"Anular Acción de Personal"}
                asyncAfterOnClose={() => OnCloseModalAnulacion()}
                labelObservacion={"Indique el motivo de anulación"}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                maxLength={500}
            />
        </div>
    )
}